<template>
  <div class="printerManage">
    <van-button
      color="#31B158"
      type="primary"
      class="add_btn"
      block
      @click="$router.push('/mine/printer/addPrinter')"
    >添加打印机</van-button>
     <!--<van-button
      color="#31B158"
      type="warning"
      class="test_btn"
      block
      @click="testPrinter"
    >测试打印机</van-button> -->

 <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getList">
      <van-cell-group>
        <van-cell
          v-for="(item,i) in list"
          :key="i"
          :title="'编号:'+item.sn"
          :value="item.status==='1'?'启用':'禁用'"
          is-link
          @click="toPrinterDetail(item.id)"
        />
      </van-cell-group>
    </van-list>
    
   <div style="height:1rem"></div>
    
  </div>
</template>

<script>
import { printer_list } from "@/api/work/mine/printer.js";
export default {
  name: "printerManage",
  data() {
    return {
      list: [],
      loading: true,
      finished: true,
      page: 1,
      pageSize: 20
    };
  },
  created() {
    this.getList();
    this.$navigation.on("back", (to, from) => {
      if (from.route.name == "mine_printer_addPrinter") {
        this.page=1;
        this.getList();
      }
    });
  },
  methods: {
    getList() {
      printer_list({ page: this.page, pageSize: this.pageSize }).then(res => {
        if (res.code == 200) {
          if (this.page == 1) {
            this.list = res.data.list;
          } else {
            this.list = this.list.concat(res.data.list);
          }
          if (res.data.totalCount== this.list.length||res.data.list.length==0) {
            this.finished = true;
          }else{
             this.finished = false;
          }
          this.loading=false;
          this.page = this.page + 1;
        }
      });
    },
    toPrinterDetail(val) {
      this.$router.push({
        path: "/mine/printer/AddPrinter",
        query: {
          id: val
        }
      });
    },
    //测试打印机
    testPrinter(){
      console.log(111)
      plus.bridge.exec('sunmiPrint','testPrint',[1,1])
    }
  }
};
</script>

<style lang="less" scoped>
.printerManage {
  position: relative;
  .test_btn{
    position: fixed;
    bottom: 2rem;
    left: 0;
  }
  .add_btn {
    position: fixed;
    z-index: 99;
    bottom: 0;
    left: 0;
    width: 100%;
  }
}
</style>